import React from 'react'
import Link from 'gatsby-link'

import Liver from '../../assets/liver.svg'
import Biohazard from '../../assets/biohazard.svg'
import Gene from '../../assets/gene.svg'
import Symptoms from '../../assets/patient-vomitting.svg'
import Gel from '../../assets/gel.svg'
import MedicalCase from '../../assets/medical-case.svg'
import Checkboard from '../../assets/checkboard.svg'
import Patient from '../../assets/patient.svg'
import Umbrella from '../../assets/umbrella.svg'
import Home from '../../assets/home.svg'
import './categories.scss'

const Categories = ({ page }) => {
  return (
    <div data-page={page} className="categories">
      <Link className="btn" to="/category/risk/">
        <img className="btn-img" src={Biohazard} alt="" />
        <span className="btn-text">Who is at risk</span>
      </Link>
      <Link className="btn" to="/category/symptoms/">
        <img className="btn-img" src={Symptoms} alt="" />
        <span className="btn-text">Symptoms</span>
      </Link>
      <Link className="btn" to="/category/diagnosis/">
        <img className="btn-img" src={Gene} alt="" />
        <span className="btn-text">Diagnosis</span>
      </Link>
      <Link className="btn" to="/category/treatment/">
        <img className="btn-img" src={Gel} alt="" />
        <span className="btn-text">Treatment</span>
      </Link>
      <Link className="btn" to="/category/complications/">
        <img className="btn-img" src={Checkboard} alt="" />
        <span className="btn-text">Complications</span>
      </Link>
      <Link className="btn" to="/category/living-with/">
        <img className="btn-img" src={MedicalCase} alt="" />
        <span className="btn-text">Living with HCV</span>
      </Link>
      <Link className="btn" to="/category/prevention/">
        <img className="btn-img" src={Umbrella} alt="" />
        <span className="btn-text">Prevention</span>
      </Link>
      <Link className="btn" to="/">
        <img className="btn-img" src={Home} alt="" />
        <span className="btn-text">Home</span>
      </Link>
    </div>
  )
}

export default Categories



// WEBPACK FOOTER //
// ./src/components/categories/categories.js